class Ownership {

    constructor() {
        this._getObjects();
    }

    _getObjects() {
        this.urlOwnership = window.appvars.services.assignments.ownership;
        this.codFlowExecuteTask = document.querySelector('#inpCodFlowExecuteTask').value;
        this.codFlowExecute = document.querySelector('#inpCodFlowExecute').value;
    }

    async claim (callbackFunction) {

        const url = this.urlOwnership.replace('{codFlowExecuteTask}', this.codFlowExecuteTask);
        var ret = await this._callApi(url, 'PATCH', { so: 'claim' });

        if (!ret?.success?.cfet)
            return false;

        if (callbackFunction && typeof callbackFunction == 'function')
            callbackFunction(ret);

        let containerMoreResponsibles = execv2.util.safeGetElementById("containerMoreResponsibles");
        containerMoreResponsibles.hidden = true;

        let containerOnlyResponsible = execv2.util.safeGetElementById("msgOnlyResponsible");
        containerOnlyResponsible.hidden = false;

        return true;

    }

    async unclaim (callbackFunction) {

        const url = this.urlOwnership.replace('{codFlowExecuteTask}', this.codFlowExecuteTask);
        var ret = await this._callApi(url, 'PATCH', { so: 'unclaim' });

        if (!ret?.success?.cfet)
            return false;

        if (callbackFunction && typeof callbackFunction == 'function')
            callbackFunction(ret);

        let containerMoreResponsibles = execv2.util.safeGetElementById("containerMoreResponsibles");
        containerMoreResponsibles.hidden = false;

        let containerOnlyResponsible = execv2.util.safeGetElementById("msgOnlyResponsible");
        containerOnlyResponsible.hidden = true;

        return true;

    }

    async confirm(callbackFunction) {

        const url = window.appvars.services.assignments.confirm.replace('{codFlowExecuteTask}', this.codFlowExecuteTask);
        var ret = await this._callApi(url, 'GET', null);

        if (!ret?.success?.ito) 
            return false;

        if (callbackFunction && typeof callbackFunction == 'function')
            callbackFunction(ret);

        return true;
    }

    async iAmTheOwner() {

        const url = globalThis.appvars.services.assignments.iamtheowner.replace('{codFlowExecuteTask}', this.codFlowExecuteTask);
        const ret = await this._callApi(url, 'GET', null);

        return ret;
    }

    async countTasks() {

        const url = globalThis.appvars.services.instanceTasks.numberOfTasks.replace('{codFlowExecute}', this.codFlowExecute);
        const ret = await this._callApi(url, 'GET', null);

        return ret;
    }

    async _callApi (url, method, body) {

        var requestOptions = {};

        requestOptions.method = method;

        var afToken = document.querySelector("input[name=__RequestVerificationToken]");
        if (!afToken)
            return null;
        var myHeaders = new Headers({ 'X-SML-AntiForgeryToken': afToken.value });

        if (method != 'GET') {
            myHeaders.append('Accept', 'application/json')
            myHeaders.append('Content-Type', 'application/json')
            requestOptions.body = JSON.stringify(body);
        }

        requestOptions.headers = myHeaders;
        var result;
        await fetch(url, requestOptions)
            .then(response => response.json())
            .then(rst => {
                result = rst;
            })
            .catch(error => {
                result = null;
            })
        return result
    }
}

